import { useState } from "react";
import * as Yup from "yup";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import axios from "axios";
import { useAuth } from "../core/Auth";
import { getUserByToken, getexpiredstatus } from "../core/_requests";

const SSO_URL = process.env.REACT_APP_SSO_URL;

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Wrong email format")
    .min(3)
    .max(50)
    .required("Email is required"),
  password: Yup.string()
    .min(3)
    .max(50)
    .required("Password is required"),
});

const initialValues = {
  email: "",
  password: "",
};

export function Login() {
  const [loading, setLoading] = useState(false);
  const { saveAuth, setCurrentUser } = useAuth();

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      try {
        const normalizedEmail = values.email.toLowerCase();
        const encodedPassword = btoa(values.password); 


        const payload = {
          username: normalizedEmail,
          password: encodedPassword,
        };

        const response = await axios.post("http://localhost:8000/users/login", payload, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        const auth = response.data;
        saveAuth(auth);

        const { data: user }: any = await getUserByToken(auth.access_token);
        setCurrentUser(user);

        await getexpiredstatus(auth.access_token);
        localStorage.setItem("userData", JSON.stringify(user));
      } catch (error) {
        console.error("Login failed:", error);
        saveAuth(undefined);
        setStatus("The login details are incorrect");
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  return (
    <form className="form w-100" onSubmit={formik.handleSubmit} noValidate>
      {formik.status && (
        <div className="mb-lg-15 alert alert-danger">
          <div className="alert-text font-weight-bold">{formik.status}</div>
        </div>
      )}

      <div className="fv-row mb-8">
        <label className="form-label fs-6 fw-bolder text-dark">Email</label>
        <input
          type="email"
          {...formik.getFieldProps("email")}
          className={clsx("form-control bg-transparent", {
            "is-invalid": formik.touched.email && formik.errors.email,
            "is-valid": formik.touched.email && !formik.errors.email,
          })}
          autoComplete="off"
        />
        {formik.touched.email && formik.errors.email && (
          <div className="fv-plugins-message-container">
            <span role="alert">{formik.errors.email}</span>
          </div>
        )}
      </div>

      <div className="fv-row mb-3">
        <label className="form-label fw-bolder text-dark fs-6 mb-0">Password</label>
        <input
          type="password"
          {...formik.getFieldProps("password")}
          className={clsx("form-control bg-transparent", {
            "is-invalid": formik.touched.password && formik.errors.password,
            "is-valid": formik.touched.password && !formik.errors.password,
          })}
          autoComplete="off"
        />
        {formik.touched.password && formik.errors.password && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span role="alert">{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>

      <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
        <Link to="/auth/forgot-password" className="link-primary">
          Forgot Password?
        </Link>
      </div>

      <div className="d-grid mb-10">
        <button
          type="submit"
          className="btn btn-primary"
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading ? (
            <span className="indicator-label">Login</span>
          ) : (
            <span className="indicator-progress" style={{ display: "block" }}>
              Please wait...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>
      </div>

      <div>
        <a
          href={SSO_URL}
          className="btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100"
        >
          <i className="fab fa-microsoft" style={{ color: "#010409", paddingRight: "10px" }}></i>
          Employee Login
        </a>
      </div>
    </form>
  );
}
